import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=07adbd2e"
import script from "./PartnersPage.vue?vue&type=script&lang=js"
export * from "./PartnersPage.vue?vue&type=script&lang=js"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&id=07adbd2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports